import store from '../store/'

const message = {
    store: store,
    success(messageText) {
        this.store.dispatch("showMessage", {messageText, messageType: "success", action: "show"});
    },
    error(messageText) {
        this.store.dispatch("showMessage", {messageText, messageType: "error", action: "show"});
    },
    info(messageText) {
        this.store.dispatch("showMessage", {messageText, messageType: "info", action: "show"});
    },
    warn(messageText) {
        this.store.dispatch("showMessage", {messageText, messageType: "warning", action: "show"});
    }
}

message.install = Vue => {
    Vue.prototype.$message = message
}

export default message;